<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0 ma-0">
      <v-tabs
        v-model="tab"
        centered
        grow
      >
        <v-tab
          v-if="mostrarVista(18)"
          href="#tipos_subtipos"
          @click="actualizarItems('tipos_subtipos')"
        >
          Tipos y Subtipos
        </v-tab>
      </v-tabs>
          
      <v-tabs-items v-model="tab">
        <v-tab-item
          value="tipos_subtipos"
        >
          <resguardo-tipo
            ref="tipos_subtipos"
          ></resguardo-tipo>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import ResguardoTipo from './ResguardoActivos/ResguardoTipo.vue'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['ids_vistas', 'vinculado'])
  },
  components:{
    ResguardoTipo
  },
  data: () => ({
    tab: 'tipos_subtipos'
  }),
  methods: {
    mostrarVista(id_vista){
			if(this.ids_vistas == null || this.ids_vistas.length == 0) return false;
			return (this.ids_vistas.indexOf(id_vista) >= 0);
		},
    getItems(){
      this.actualizarItems(this.tab);
    },
    actualizarItems(refName) {
      if (this.$refs[refName] && this.$refs[refName].getItems) {
        this.$refs[refName].getItems();
      } else {
        console.warn(`No se encontró la referencia: ${refName}`);
      }
    }
  }
}
</script>